import { Theme } from "../component/navigation/ThemeDropdown";

export default function HomeIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                {/* Outer Circle */}
                <path
                    d="M12 23.9969C18.6274 23.9969 24 18.625 24 11.9985C24 5.3719 18.6274 0 12 0C5.37258 0 0 5.3719 0 11.9985C0 18.625 5.37258 23.9969 12 23.9969Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Middle Rectangle */}
                <path
                    d="M5.67023 10.5574H17.6519V16.5292C17.6519 16.8528 17.3893 17.1154 17.0656 17.1154H6.25343C5.92977 17.1154 5.66718 16.8528 5.66718 16.5292V10.5574H5.67023Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Top Triangle */}
                <path
                    d="M11.3252 5.35811L5.67023 10.5605H17.6519L12.287 5.37032C12.0183 5.11081 11.5969 5.10471 11.3221 5.35811H11.3252Z"
                    fill={
                        isSelected
                            ? theme === "light"
                                ? "#FFFFFF"
                                : "#2D3748"
                            : theme === "dark"
                              ? "#2D3748"
                              : "#606161"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Inner Shape */}
                <path
                    d="M10.3847 13.1006H12.9374C13.1847 13.1006 13.3863 13.3021 13.3863 13.5494V17.1154H9.93588V13.5494C9.93588 13.3021 10.1374 13.1006 10.3847 13.1006Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
